import React from 'react';
import { getLevelProgress, formatAura } from '../lib/aura';
import { useI18n } from '../context/I18nContext';

export default function LevelProgress({ points = 0 }) {
  const { t } = useI18n();
  const { percent, pointsToNext, current, next } = getLevelProgress(points);
  return (
    <div data-testid="level-progress" className="w-full">
      <div className="flex items-center justify-between mb-2">
        <div
          className="font-display font-bold tracking-widest text-xs uppercase"
          style={{ color: current.color }}
          data-testid="level-current-name"
        >
          {t(current.key)}
        </div>
        {next ? (
          <div className="text-xs text-aura-textDim">
            <span className="text-white/80 font-mono">{formatAura(points)}</span>
            <span className="mx-1 opacity-40">/</span>
            <span className="font-mono">{formatAura(next.min)}</span>
          </div>
        ) : (
          <div className="text-xs font-display font-bold text-aura-pink">{t('levels.max')}</div>
        )}
      </div>

      <div className="relative h-2 rounded-full bg-white/5 overflow-hidden border border-white/5">
        <div
          className="absolute inset-y-0 left-0 rounded-full bg-aura-gradient transition-[width] duration-700"
          style={{
            width: `${percent}%`,
            boxShadow: '0 0 14px rgba(0,240,255,0.7), 0 0 24px rgba(176,38,255,0.5)',
          }}
        />
      </div>

      {next && (
        <div className="mt-2 text-xs text-aura-textDim">
          <span className="text-white/90 font-mono">{formatAura(pointsToNext)}</span>{' '}
          <span>AURA {t('profile.nextLevel')}</span>{' '}
          <span className="font-display font-semibold" style={{ color: next.color }}>{t(next.key)}</span>
        </div>
      )}
    </div>
  );
}
